import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Kit después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un correo con el link de descarga de todos los archivos en formato PDF. El acceso es instantáneo, las 24 horas, los 7 días de la semana.'
}, {
  q: '¿Sirve si mi hijo tiene ansiedad leve?',
  a: 'Sí. El kit está diseñado para todos los niveles de ansiedad: leve, moderada y severa. De hecho cuanto antes lo aplicás, mejores y más rápidos son los resultados.'
}, {
  q: '¿Necesito conocimientos previos?',
  a: 'No. Todo el kit está escrito para madres sin formación técnica. Las herramientas son concretas, los guiones son exactos y los protocolos tienen pasos numerados. No necesitás interpretar nada.'
}, {
  q: '¿Los bonos están incluidos en las dos opciones?',
  a: 'Sí. Los 3 bonos están incluidos tanto en el Kit base como en el Kit Completo con PRO. Sin costo extra en ninguna de las dos opciones.'
}, {
  q: '¿Sirve si vivo en el interior del país?',
  a: 'Sí. El kit está adaptado al contexto argentino en general: sistema educativo, acceso a recursos de salud mental, vocabulario y situaciones cotidianas reconocibles para madres de todo el país.'
}, {
  q: '¿Funciona si mi hijo ya va al psicólogo?',
  a: 'Sí. El kit no reemplaza el trabajo profesional, lo complementa. Todo lo que aprendés acá podés conversarlo con el profesional que lo atiende y aplicarlo en el hogar como parte del mismo proceso.'
}, {
  q: '¿Qué diferencia tiene con buscar en Google?',
  a: 'Los grupos de Facebook dan opiniones. Google da información descontextualizada. Este kit es un sistema ordenado, con protocolos específicos, adaptado al contexto argentino, con una secuencia lógica de aplicación. No es información suelta. Es un sistema.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total sin preguntas. Si no es lo que esperabas te devolvemos el 100% del dinero. Sin formularios, sin drama, sin excusas.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="relative w-full bg-[#F8F6FF] py-12 sm:py-16 md:py-20" data-id="element-44">
      <div className="mx-auto max-w-[720px] px-5" data-id="element-45">
        <div className="mb-12 text-center" data-id="element-46">
          <span className="mb-4 inline-block rounded-full bg-[#6B21A8] px-3 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-47">
            DUDAS COMUNES
          </span>
          <h2 className="font-heading text-3xl font-bold text-[#1A0A2E] sm:text-4xl md:text-5xl" data-id="element-48">
            Preguntas
            <br data-id="element-49" />
            <span className="text-violet-gradient" data-id="element-50">Frecuentes</span>
          </h2>
        </div>

        <div className="flex flex-col gap-4" data-id="element-51">
          {faqs.map((faq, i) => <div key={i} className="overflow-hidden rounded-[16px] border border-[#A855F7]/30 bg-white shadow-card-light" data-id="element-52">
              <div className="flex" data-id="element-53">
                <div className="w-[3px] bg-[#6B21A8] flex-shrink-0" data-id="element-54" />
                <div className="flex-1" data-id="element-55">
                  <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="flex w-full items-center justify-between p-5 text-left focus:outline-none sm:p-6" data-id="element-56">
                    <span className="font-bold text-[#1A0A2E] sm:text-[17px]" data-id="element-57">
                      {faq.q}
                    </span>
                    <ChevronRight className={`ml-4 flex-shrink-0 text-[#6B21A8] transition-transform duration-300 ${openIndex === i ? 'rotate-90' : ''}`} size={20} data-id="element-58" />
                  </button>
                  <AnimatePresence data-id="element-59">
                    {openIndex === i && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-60">
                        <div className="border-t border-dashed border-[#A855F7]/20 bg-[#F8F6FF] p-5 sm:p-6" data-id="element-61">
                          <p className="text-[15px] leading-relaxed text-[#4B3B6B]" data-id="element-62">
                            {faq.a}
                          </p>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};